import React from "react";
import imgBanner from "../assets/banner5.png";
import "./Banner.css";

const Banner = () => {
    return (
    <div>
        <img src={imgBanner} className="baner" alt="banner"/>
    </div>
);
}


export default Banner;
